import { TCoordinate } from "@api/api.int";
import { BoxProps, ButtonGroup, IconButton, Tooltip } from "@chakra-ui/react";
import { useDeepAuth } from "components/api";
import { NEW_LOCATION_ZOOM } from "components/appComponents";
import { useVVStore } from "components/store";
import { VizvCard, VizvMainCol } from "components/vizvComponents";
import { useState } from "react";
import { MdLocationCity, MdLocationSearching, MdZoomOutMap } from "react-icons/md";
import { HUNGARY_CENTER } from "./MyMap";

export interface MapToolsProps extends BoxProps {
    onMyLocationClick?: (longLat: TCoordinate) => void;
}


export function MapTools({ onClick, onMyLocationClick, ...rest }: MapToolsProps) {



    const setMapMoveIntoView = useVVStore(state => state.setMapMoveIntoView);
    const myProfile = useVVStore(state => state.myProfile);



    const OrszagClick = () => {
        setMapMoveIntoView({ zoom: 8.0, center: HUNGARY_CENTER });
        if (onClick)
            onClick(null as any);
    }

    const MyLocationClick = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const longLat: TCoordinate = [position.coords.longitude, position.coords.latitude];

                if (onMyLocationClick) {
                    onMyLocationClick(longLat);
                } else {
                    setMapMoveIntoView({ zoom: NEW_LOCATION_ZOOM, center: longLat });
                }

            });
        }

        if (onClick && !onMyLocationClick)
            onClick(null as any);
    }

    const MyGuardClick = () => {
        if (myProfile?.guard?.longLat)
            setMapMoveIntoView({ zoom: NEW_LOCATION_ZOOM, center: myProfile?.guard?.longLat });
        if (onClick)
            onClick(null as any);
    }
    //colorScheme='black' color='#fffa'

    return <ButtonGroup  {...rest} 
        //colorScheme='secondary' 
        size='sm' >
        <Tooltip label='Magyarország' placement="top" hasArrow>
            <IconButton aria-label="Magyarország" icon={<MdZoomOutMap />} onClick={OrszagClick} />
        </Tooltip>
        <Tooltip label={myProfile?.guard?.locationTitle} placement="top" hasArrow>
            <IconButton aria-label="VízVédő helyem" icon={<MdLocationCity />} isDisabled={!myProfile?.guard?.longLat} onClick={MyGuardClick} />
        </Tooltip>
        <Tooltip label='Jelenlegi tartózkodási helyem' placement="top" hasArrow>
            <IconButton aria-label="Tartózkodási helyem" icon={<MdLocationSearching />} onClick={MyLocationClick} />
        </Tooltip>
    </ButtonGroup>
}

export function MapToolsColumn() {
    return <VizvMainCol isTool={{ width: 180, isDetailed: false, isMainMapTool: true }}>
        <VizvCard isTool p={1} fontSize='sm' gap={1} flexDir='row' alignItems='flex-start'>
            <MapTools mt={4} ml='auto' />
        </VizvCard>
    </VizvMainCol>

}